import React from "react";
import { ModalBody } from "reactstrap";
import LostPasswordForm from './LostPasswordForm'


const LostPasswordBody = () => {
    return(
        <ModalBody>
        If there is an email associated with the given username, a password reset will be sent directly to you. Otherwise, your administrators will be notified you're requesting a password reset.
        <LostPasswordForm />
        </ModalBody>
    )
}

export default LostPasswordBody